import * as React from "react";
import { useCallback, useMemo } from "react";
import useIBuyApprovals from "../../services/apiUtils/hooks/useIBuyApprovals";
import useServiceNowApprovals from "../../services/apiUtils/hooks/useServiceNowApprovals";
import { taskTypeToCard } from "../../constants/taskNames";
import useMyLearningCourses from "services/apiUtils/hooks/useMyLearningCourses";
import useExpenseClaims from "services/apiUtils/hooks/useExpenseClaims";

const useTasks = () => {
    const { serviceNowApprovals, serviceNowApprovalsAreLoading } =
        useServiceNowApprovals();
    const { approvals, iBuyApprovalsAreLoading } = useIBuyApprovals();
    const { coursesList, coursesAreLoading } = useMyLearningCourses();
    const { expenseClaimRecords, expenseClaimRecordsAreLoading } =
        useExpenseClaims();

    const taskUnion = React.useMemo(() => {
        const tasks = [
            // expensesItems,
            approvals,
            serviceNowApprovals,
            coursesList,
            expenseClaimRecords,
        ];
        return tasks
            .flat()
            .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    }, [approvals, serviceNowApprovals, coursesList, expenseClaimRecords]);

    const tasksAreLoading = useMemo(
        () =>
            serviceNowApprovalsAreLoading ||
            iBuyApprovalsAreLoading ||
            coursesAreLoading ||
            expenseClaimRecordsAreLoading,

        [
            serviceNowApprovalsAreLoading,
            iBuyApprovalsAreLoading,
            coursesAreLoading,
            expenseClaimRecordsAreLoading,
        ]
    );

    const taskCards = useCallback(
        (tasks, isDashboard = true) => {
            if (tasks) {
                return tasks.map((task) => {
                    const Card = taskTypeToCard[task.taskType];
                    return (
                        Card && (
                            <Card
                                key={`${task.taskType}-${task.id}`}
                                id={task.id}
                                isDashboard={isDashboard}
                            />
                        )
                    );
                });
            }
            return [];
        },
        [approvals, serviceNowApprovals]
    );

    return { taskUnion, tasksAreLoading, taskCards };
};
export default useTasks;
